import { render, staticRenderFns } from "./SelectedItem.vue?vue&type=template&id=63fd117c&scoped=true&"
import script from "./SelectedItem.vue?vue&type=script&lang=js&"
export * from "./SelectedItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectedItem.vue?vue&type=style&index=0&id=63fd117c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd117c",
  null
  
)

export default component.exports